import React, { useCallback, useRef, useState } from 'react';
import CookieBar from './cookieBar';
import CookieDialog from './cookieDialog';
import SettingsButton from './settingsButton';
import { DEFAULT_COOKIE_POLICY_URL, DEFAULT_LOGO_ALT } from './text';
import useCookieConsent from './useCookieConsent';
import './cookieConsent.css';

// Cookie bar, settings dialog and gear button. Everything the host app supplies comes in as
// props, so the component carries over to another React app unchanged.
function CookieConsent({ measurementId, logoSrc, logoAlt = DEFAULT_LOGO_ALT, cookiePolicyUrl = DEFAULT_COOKIE_POLICY_URL, reload }) {
    const consent = useCookieConsent({ reload, measurementId });
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const gearRef = useRef(null);
    const openDialog = useCallback(() => setIsDialogOpen(true), []);
    const closeDialog = useCallback(() => setIsDialogOpen(false), []);

    if (!consent.isReady) {
        return null;
    }

    function handleEnableAll() {
        consent.acceptAll();
        closeDialog();
    }

    function handleSave(isAnalyticsOn) {
        consent.saveAnalytics(isAnalyticsOn);
        closeDialog();
    }

    return (
        <>
            {!consent.hasChoice && (
                <CookieBar
                    cookiePolicyUrl={cookiePolicyUrl}
                    onAccept={consent.acceptAll}
                    onReject={consent.rejectAll}
                    onManage={openDialog}
                />
            )}
            {/* Stays mounted behind the dialog overlay so closing the dialog returns focus to it. */}
            {consent.hasChoice && <SettingsButton buttonRef={gearRef} onClick={openDialog} />}
            {isDialogOpen && (
                <CookieDialog
                    logoSrc={logoSrc}
                    logoAlt={logoAlt}
                    cookiePolicyUrl={cookiePolicyUrl}
                    analyticsEnabled={consent.analyticsAccepted}
                    returnFocusRef={gearRef}
                    onClose={closeDialog}
                    onEnableAll={handleEnableAll}
                    onSave={handleSave}
                />
            )}
        </>
    );
}

export default CookieConsent;
